<template>
  <!-- NOTE (TEMPLATE) to show the refree reviews -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/referee/reviews'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-reviews) to show the refree reviews list -->
      <b-table
        responsive
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="computedJudgments"
        :current-page="currentPage"
        :per-page="perPage"
        empty-text="طرحی برای داوری وجود ندارد"
        striped
        :busy="isBusy"
        :filter="filter"
        @filtered="onFiltered"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div
            style="
              text-align: center;
              vertical-align: middle;
              width: 150px;
              margin: auto;
            "
          >
            <!-- NOTE (<a>) to submit new review -->
            <a
              v-if="data.item.requestType == 'project'"
              class="btn btn-success white--text mx-1"
              style="width: 100%"
              :href="
                '/referee/reviewProposal/' +
                data.item.requestId +
                '/' +
                data.item.id
              "
              target="_blank"
              >ثبت داوری</a
            >
            <a
              v-if="data.item.requestType == 'phd'"
              class="btn btn-success white--text mx-1"
              style="width: 100%"
              :href="
                '/referee/reviewPhd/' + data.item.requestId + '/' + data.item.id
              "
              target="_blank"
              >ثبت داوری</a
            >
            <a
              v-if="data.item.requestType == 'master'"
              class="btn btn-success white--text mx-1"
              style="width: 100%"
              :href="
                '/referee/reviewMaster/' +
                data.item.requestId +
                '/' +
                data.item.id
              "
              target="_blank"
              >ثبت داوری</a
            >
            <a
              v-if="data.item.requestType == 'opportune'"
              class="btn btn-success white--text mx-1"
              style="width: 100%"
              :href="
                '/referee/reviewOpportunity/' +
                data.item.requestId +
                '/' +
                data.item.id
              "
              target="_blank"
              >ثبت داوری</a
            >
            <a
              v-if="data.item.requestType == 'meeting'"
              class="btn btn-success white--text mx-1"
              style="width: 100%"
              :href="
                '/referee/reviewMeeting/' +
                data.item.requestId +
                '/' +
                data.item.id
              "
              target="_blank"
              >ثبت داوری</a
            >
            <a
              v-if="data.item.requestType == 'postDoc'"
              class="btn btn-success white--text mx-1"
              style="width: 100%"
              :href="
                '/referee/reviewPostDoc/' +
                data.item.requestId +
                '/' +
                data.item.id
              "
              target="_blank"
              >ثبت داوری</a
            >
            <a
              v-if="data.item.requestType == 'article'"
              class="btn btn-success white--text mx-1"
              style="width: 100%"
              :href="
                '/referee/reviewArticle/' +
                data.item.requestId +
                '/' +
                data.item.id
              "
              target="_blank"
              >ثبت داوری</a
            >
            <a
              v-if="data.item.requestType == 'elite'"
              class="btn btn-success white--text mx-1"
              style="width: 100%"
              :href="
                '/referee/reviewElite/' +
                data.item.requestId +
                '/' +
                data.item.id
              "
              target="_blank"
              >ثبت داوری</a
            >
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 + perPage * (currentPage - 1) }}
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        first-text="ابتدا"
        prev-text="قبلی"
        next-text="بعدی"
        last-text="آخر"
        align="center"
        size="sm"
        class="my-0"
      ></b-pagination>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import { EventBus } from "../../main"; // REVIEW

export default {
  components: {},
  data: function () {
    return {
      fields: [
        { key: "index", label: "ردیف" },
        { key: "faSubject", label: "عنوان فارسی" },
        { key: "judgeCode", label: "کد داوری" },
        { key: "type", label: "نوع حمایت" },
        { key: "operation", label: "عملیات" },
      ],
      // items: [{ faSubject: 'test1' , project_status: 'نیاز به تکمیل'}, { faSubject: 'test2', project_status: 'ثبت شده' }],
      items: [],
      filter: "",
      isBusy: true,
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
    };
  },
  watch: {
    $route: function () {
      this.onMounted();
    },
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      EventBus.$on("refereeAdded", () => {
        this.isBusy = true;
        this.$http
          .post(
            this.baseUrl + "/setad/reviewer/reviews/actives",
            {},
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.items = res.data;
            this.isBusy = false;
            this.totalRows = this.items.length;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            if (err.response.status == 403 || 401) {
              this.$router.push({
                path: "/unauthorize",
                query: { return: window.location.pathname },
              });
            }
            this.isBusy = false;
            // }
          });
      });
      this.$http
        .post(
          this.baseUrl + "/setad/reviewer/reviews/actives",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.items = res.data;
          this.isBusy = false;
          this.totalRows = this.items.length;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403 || 401) {
            this.$router.push({
              path: "/unauthorize",
              query: { return: window.location.pathname },
            });
          }
          this.isBusy = false;
          // }
        });
    },
  },
  computed: {
    computedJudgments() {
      if (this.items) {
        return this.items.sort((a, b) => {
          if (a.time < b.time) {
            return 1;
          }
          if (a.time > b.time) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
  },
  mounted() {
    this.onMounted();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
